var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 197,
    viewBox: "0 0 222 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M221.406 12.7654C183.009 -1.77386 141.028 -3.95276 101.332 6.53324C61.6362 17.0192 26.208 39.6461 0 71.2513L151.645 197L221.406 12.7654Z",
    fill: "url(#paint0_linear_237_218)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_237_218",
    x1: 187.645,
    y1: 70,
    x2: 85.1452,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8BE8D",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8BE8D",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadar);
export default __webpack_public_path__ + "static/media/radar.4ccbd3ac782c097c83ab3a2072847bb4.svg";
export { ForwardRef as ReactComponent };